/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';
import {Observable} from 'rxjs';
import {BwEtree} from '../model/bwEtree';
import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';

@Injectable()
export class BwEtreeService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Removes the BwEtree resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBwEtreeItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;

  public deleteBwEtreeItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;

  public deleteBwEtreeItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;

  public deleteBwEtreeItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteBwEtreeItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.delete<any>(`${this.basePath}/api/bw_etrees/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of all Bw Etrees
   *
   * @param source
   * @param source2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBwEtreeCollection(source?: string, source2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<BwEtree>>;

  public getBwEtreeCollection(source?: string, source2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BwEtree>>>;

  public getBwEtreeCollection(source?: string, source2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BwEtree>>>;

  public getBwEtreeCollection(source?: string, source2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (source !== undefined) {
      queryParameters = queryParameters.set('source', <any>source);
    }
    if (source2) {
      source2.forEach((element) => {
        queryParameters = queryParameters.append('source[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<BwEtree>>(`${this.basePath}/api/bw_etrees`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of all Bw Etrees
   *
   * @param source
   * @param source2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public clientRefsBwEtreeCollection(source?: string, source2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<BwEtree>>;

  public clientRefsBwEtreeCollection(source?: string, source2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BwEtree>>>;

  public clientRefsBwEtreeCollection(source?: string, source2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BwEtree>>>;

  public clientRefsBwEtreeCollection(source?: string, source2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (source !== undefined) {
      queryParameters = queryParameters.set('source', <any>source);
    }
    if (source2) {
      source2.forEach((element) => {
        queryParameters = queryParameters.append('source[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<BwEtree>>(`${this.basePath}/api/etrees-client-refs`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a BwEtree resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBwEtreeItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<BwEtree>;

  public getBwEtreeItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BwEtree>>;

  public getBwEtreeItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BwEtree>>;

  public getBwEtreeItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getBwEtreeItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<BwEtree>(`${this.basePath}/api/bw_etrees/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a BwEtree resource.
   *
   * @param bwEtree The new BwEtree resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postBwEtreeCollection(bwEtree?: BwEtree, observe?: 'body', reportProgress?: boolean): Observable<BwEtree>;

  public postBwEtreeCollection(bwEtree?: BwEtree, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BwEtree>>;

  public postBwEtreeCollection(bwEtree?: BwEtree, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BwEtree>>;

  public postBwEtreeCollection(bwEtree?: BwEtree, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<BwEtree>(`${this.basePath}/api/bw_etrees`,
      bwEtree,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Replaces the BwEtree resource.
   *
   * @param id
   * @param bwEtree The updated BwEtree resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putBwEtreeItem(id: string, bwEtree?: BwEtree, observe?: 'body', reportProgress?: boolean): Observable<BwEtree>;

  public putBwEtreeItem(id: string, bwEtree?: BwEtree, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BwEtree>>;

  public putBwEtreeItem(id: string, bwEtree?: BwEtree, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BwEtree>>;

  public putBwEtreeItem(id: string, bwEtree?: BwEtree, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putBwEtreeItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<BwEtree>(`${this.basePath}/api/bw_etrees/${encodeURIComponent(String(id))}`,
      bwEtree,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
